import { keepPreviousData } from "@tanstack/react-query";
import dayjs from "dayjs";

import { DashboardFigure } from "@components/Dashboards/shell";

import { useClientEmployeeAppUsageCountQuery } from "./EmployeeAppCountUsageStat.g";

type Props = {
  clientEmployeeId: string;
  clientId: string;
  dateRange?: [Date | null, Date | null];
  applicationResourceId?: string;
  windowLabel?: string;
  prominent?: boolean;
};

export const EmployeeAppCountUsageStat = ({
  clientEmployeeId,
  dateRange,
  applicationResourceId,
  windowLabel,
  prominent,
}: Props) => {
  const { data, isLoading } = useClientEmployeeAppUsageCountQuery(
    {
      employeeId: clientEmployeeId,
      ...(dateRange?.[0] && {
        dateFrom: dayjs(dateRange[0]).format("YYYY-MM-DD"),
      }),
      ...(dateRange?.[1] && {
        dateTo: dayjs(dateRange[1]).format("YYYY-MM-DD"),
      }),
      ...(applicationResourceId && { applicationResourceId }),
    },
    {
      placeholderData: keepPreviousData,
    },
  );

  const appCount = data?.clientEmployeeApplicationInteractions?.filteredCount;

  return (
    <DashboardFigure
      prominent={prominent}
      label="Number of used apps"
      value={(appCount ? appCount : 0).toString()}
      detail={windowLabel}
      isLoading={isLoading}
    />
  );
};
